import { render, staticRenderFns } from "./addActivityGroup.vue?vue&type=template&id=363064ee&scoped=true"
import script from "./addActivityGroup.vue?vue&type=script&lang=js"
export * from "./addActivityGroup.vue?vue&type=script&lang=js"
import style0 from "./addActivityGroup.vue?vue&type=style&index=0&id=363064ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363064ee",
  null
  
)

export default component.exports